import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthFacade, NotificationService} from 'af-services';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent implements OnInit {
  form: FormGroup;
  show = false;
  showConfirm = false;
  error;
  email;
  success = false;
  showCaptcha = true;
  private busy = false;


  constructor(private route: ActivatedRoute, private router: Router, private notify: NotificationService,
              private authFacade: AuthFacade, private fb: FormBuilder,
              @Inject('captchaKey') public captchaKey,
              @Inject('afterLoginRedirectTo') private afterLoginRedirectTo) {

    const isComingBack = localStorage.getItem('googleAuth');

    if (isComingBack) {
      this.notify.info('Registration', 'Hang on while we log you in ....');
    }
  }

  async ngOnInit() {


    this.form = this.fb.group(
      {
        acceptTerms: ['', Validators.compose([Validators.requiredTrue])],
        email: ['', Validators.compose([Validators.required, Validators.email])],
        password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        captcha: ['', Validators.compose([Validators.required])]
      }
    );


    this.authFacade.dirtyControlsOnPage('btnSubmit', this.form);
    await this.authFacade.readAndLoginWithToken('btnGoogle', (result) => {
      this.router.navigate([this.afterLoginRedirectTo]);

    }, e => {
    });


  }


  setDisabled(name, value: boolean) {

    if (value) {
      this.form.controls[name].disable();
    } else {
      this.form.controls[name].enable();
    }
  }


  async submit(callingControl) {
    const value = this.form.value;
    if (value.password !== value.confirmPassword) {
      this.error = 'Password and confirm password do not match.';
      return;
    }

    if (!value.acceptTerms) {
      this.error = 'Please click checkbox to agree to AvantForm license agreement, terms and conditions and privacy policy.';
      return;
    }

    await this.authFacade.registerWithEmailAndPassword(value, callingControl, (result) => {
      this.email = result;
      this.setDisabled('email', true);
      this.setDisabled('password', true);
      this.success = true;

    }, e => {
      if (e === 'CAN_REGISTER') {
        this.error = `Apologies! This version of AvantForm is invite only. But dont worry we'll invite you once we're open to the public.`;
      } else {
        this.error = e;
      }
      this.form.patchValue({
        captcha: null
      });
      this.showCaptcha = false;
      setTimeout(() => {
        this.showCaptcha = true;
      }, 300);
    });
  }


  showHidePassword() {
    this.show = !this.show;
  }

  showHideConfirmPassword() {
    this.showConfirm = !this.showConfirm;
  }

  googleAuth(controlId) {
    this.authFacade.googleLogin(controlId);
  }


  handleSuccessCaptcha($event: string) {
    this.form.patchValue({
      captcha: $event
    });
  }

}
